// extracted by mini-css-extract-plugin
export default {"interaction":"styles_interaction__KcchM","popup":"styles_popup__f53vP","spinner":"styles_spinner__xaw3F","interactionsMenuItemBottom":"styles_interactionsMenuItemBottom__pKrJK"};